import { render, staticRenderFns } from "./AplicativoFidelizacaoPremios.vue?vue&type=template&id=8b811cfa&scoped=true"
import script from "./AplicativoFidelizacaoPremios.vue?vue&type=script&lang=js"
export * from "./AplicativoFidelizacaoPremios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b811cfa",
  null
  
)

export default component.exports